<template>
  <div>
    <div v-if="isCurrentUser" class="wish-list-contents__items">
      <div
        v-for="userWishList in userWishLists"
        :key="userWishList.id"
        class="wish-list-content-item"
      >
        <WishListItemWithDelete
          :user-wish-list-id="userWishList.id"
          :image-url="userWishList.imageUrl"
          :brand-name="userWishList.brandName"
          :item-name="userWishList.itemName"
          :item-sku-name="userWishList.itemSkuName"
          :item-id="userWishList.itemId"
          :item-sku-id="userWishList.itemSkuId"
          :has-limit="userWishList.hasLimit"
          :is-sold-out="userWishList.isSoldOut"
          :wanted-quantity="userWishList.wantedQuantity"
          :received-quantity="userWishList.receivedQuantity"
          @click-sku-basic-information-in-with-delete="
            moveToItemSkuPage(userWishList.itemId, userWishList.itemSkuId)
          "
          @click-wish-list-item-delete="showDeleteModal"
        />
      </div>
      <TextModal
        v-if="isDeleteModalActive"
        :title-text="'ほしいものリストから削除'"
        :caption-text="'選択したギフトをほしいのものリストから削除してもよろしいですか？'"
        :primary-button-text="'削除する'"
        :cancel-button-text="'キャンセル'"
        @clicked-modal-cover="closeDeleteModal"
        @clicked-primary="deleteItemSku"
        @clicked-cancel="closeDeleteModal"
      />
    </div>
    <div v-else class="wish-list-contents__items">
      <div
        v-for="userWishList in userWishLists"
        :key="userWishList.id"
        class="wish-list-content-item"
      >
        <WishListItemWithSendButton
          :image-url="userWishList.imageUrl"
          :brand-name="userWishList.brandName"
          :item-name="userWishList.itemName"
          :item-sku-name="userWishList.itemSkuName"
          :item-id="userWishList.itemId"
          :item-sku-id="userWishList.itemSkuId"
          :has-limit="userWishList.hasLimit"
          :is-sold-out="userWishList.isSoldOut"
          :wanted-quantity="userWishList.wantedQuantity"
          :received-quantity="userWishList.receivedQuantity"
          @click-sku-basic-information-in-with-send-button="
            moveToItemSkuPage(userWishList.itemId, userWishList.itemSkuId)
          "
          @click-send-button="
            clickItem(userWishList.itemId, userWishList.itemSkuId)
          "
        />
      </div>
    </div>
    <TextModalWithSecondary
      v-if="isGiftCardModalActive && isDifferentUserAsGiftCardRecipient"
      :title-text="'作成中のギフトカードがあります'"
      :caption-text="'作成できるカードは１つまでです。\n内容を破棄して新規作成しますか?'"
      :primary-button-text="'新規作成する'"
      :secondary-button-text="'カードを確認する'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeGiftCardModal"
      @clicked-primary="createGiftCard"
      @clicked-secondary="moveToGiftCardEditPage"
      @clicked-cancel="closeGiftCardModal"
    />
  </div>
</template>

<script>
import TextModalWithSecondary from '../../../molecules/modals/with_secondary/text-modal-with-secondary.vue'
import TextModal from '../../../molecules/modals/text-modal.vue'
import WishListItemWithDelete from '../../../molecules/wish_list/WishListItemWithDelete.vue'
import WishListItemWithSendButton from '../../../molecules/wish_list/WishListItemWithSendButton.vue'

import axios from 'axios'

export default {
  components: {
    TextModalWithSecondary,
    TextModal,
    WishListItemWithDelete,
    WishListItemWithSendButton
  },
  props: {
    userWishLists: {
      type: Array,
      require: true,
      default: () => {}
    },
    isCurrentUser: {
      type: Boolean,
      require: true,
      default: false
    },
    screenName: {
      type: String,
      require: true,
      default: ''
    },
    isDifferentUserAsGiftCardRecipient: {
      type: Boolean,
      require: true,
      default: false
    },
    isApp: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isDeleteModalActive: false,
      deleteUserWishlistId: null,
      isGiftCardModalActive: false,
      selectUserWishListItemId: null,
      selectUserWishListitemSkuId: null
    }
  },
  methods: {
    clickItem(itemId, itemSkuId) {
      if (this.isApp) {
        // アプリ側ではクリック後ネイティブのギフトカード作成画面に遷移するが、カードを作成するのに情報が足りないため、パラメータで必要な情報を渡す
        location.href = `/gift_card/edit?item_sku_id=${itemSkuId}&wish_list_screen_name=${this.screenName}&via=wishlist`
        return
      }

      this.selectUserWishListItemId = itemId
      this.selectUserWishListitemSkuId = itemSkuId

      if (this.isDifferentUserAsGiftCardRecipient) {
        this.isGiftCardModalActive = true
        return
      }
      this.createGiftCard()
    },
    async createGiftCard() {
      dataLayer.push({
        event: 'add_to_cart',
        item_sku_id: this.selectUserWishListitemSkuId,
        ecommerce: {
          items: [
            {
              item_id: this.selectUserWishListitemSkuId,
              quantity: 1,
              item_list_name: 'wishlist'
            }
          ]
        }
      })

      try {
        const result = await axios.post(
          '/api/v1/pickup/gift_card_session_item_sku_contents',
          {
            item_sku_form: {
              item_id: this.selectUserWishListItemId,
              item_sku_id: this.selectUserWishListitemSkuId,
              screen_name: this.screenName
            }
          }
        )

        if (result.data.wish_list_item_reached_limit) {
          this.$emit('reached-limit-error-in-items')
          return
        }
        const path_params = result.data.wish_list_user_changed
          ? 'wish_list_changed=true'
          : ''
        location.href = `/gift_card/edit?${path_params}`
      } catch (error) {
        this.$emit('create-gift-card-error', error)
      }
    },
    closeGiftCardModal() {
      this.isGiftCardModalActive = false
      this.selectUserWishListItemId = null
      this.selectUserWishListitemSkuId = null
    },
    moveToGiftCardEditPage() {
      location.href = '/gift_card/edit'
      this.isGiftCardModalActive = false
    },
    moveToItemSkuPage(itemId, itemSkuId) {
      if (!this.isApp) {
        dataLayer.push({
          event: 'click_wishlist__wishlist_item_detail',
          item_sku_id: itemSkuId
        })
      } else {
        // eslint-disable-next-line no-undef
        logEvent('click_wishlist__wishlist_item_detail', {
          item_sku_id: itemSkuId
        })
      }
      location.href = `/items/${itemId}/item_skus/${itemSkuId}?wish_list_screen_name=${this.screenName}`
    },
    closeDeleteModal() {
      this.isDeleteModalActive = false
      this.deleteUserWishlistId = null
    },
    showDeleteModal(userWishListId) {
      this.deleteUserWishlistId = userWishListId
      this.isDeleteModalActive = true
    },
    async deleteItemSku() {
      try {
        await axios.delete(`/api/v1/wish_lists/${this.deleteUserWishlistId}`)
        this.$emit('complete-delete-item-sku')
      } catch (error) {
        this.$emit('delete-item-sku-error', {
          message: 'ほしいものリストの削除に失敗しました'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-contents {
  &__items {
    margin: auto;
  }
}
</style>
